import React from "react";
import "../style/ToolsSection.scss";

const tools = [
  { name: "CSS 3", logo: "/tools/css-3.svg" },
  { name: "Elementor", logo: "/tools/Elementor.svg" },
  { name: "Figma", logo: "/tools/figma.svg" },
  { name: "HTML", logo: "/tools/html.svg" },
  { name: "C++", logo: "/tools/c++.svg" },
  { name: "Kotlin", logo: "/tools/kotlin.svg" },
  { name: "Ruby", logo: "/tools/ruby.svg" },
  { name: "Java", logo: "/tools/java.svg" },
  { name: "Python", logo: "/tools/python.svg" },
  { name: "SQL", logo: "/tools/sql.svg" },
  { name: "Swift", logo: "/tools/swift.svg" },
  { name: "Toupet", logo: "/tools/sass.svg" },
  { name: "premiere", logo: "/tools/adobe-premiere.svg" },
  { name: "photoshop", logo: "/tools/adobe-photoshop.svg" },
  { name: "effects", logo: "/tools/adobe-after-effects.svg" },
];

const ToolsSection = () => {
  return (
    <section className="tools-section-scrol">
      <div className="tools-content">
        <div className="tools-info">
          <h2>Tools <em>we work</em> with</h2>
          <p>
            Vulpulate molestie molestie amet leo blandit accumsan. Sapien sed amet tellus purus sit odio eget. 
            Diam morbi faucibus vitae neque id in. Nullam sed et dapibus nunc.
          </p>
        </div>

        <div className="logos-container">
          <div className="logos">
            {tools.concat(tools).map((tool, index) => (
              <div className="logo-card" key={index}>
                <img src={tool.logo} alt={tool.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ToolsSection;
